import { Button } from "@pushup/ui";

interface FinishedOverlayProps {
  reps: number;
  onFinish: () => void;
}

/**
 * End-of-session overlay for a plain (non-recording) workout: final score and a
 * Finish action that returns to the idle screen. Sessions that produced a clip
 * use RecordedClipOverlay instead (download / publish / share). Plain sessions
 * are always solo — the opponent never races outside recording mode.
 */
export function FinishedOverlay({ reps, onFinish }: FinishedOverlayProps) {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/80 p-6">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-neutral-900/95 p-8 text-center shadow-2xl">
        <h2 className="text-2xl font-semibold tracking-tight text-white">Workout finished</h2>
        <p className="mt-1 text-sm text-white/60">Nice session</p>

        <div className="mt-6 flex items-center justify-center">
          <div>
            <p className="text-5xl font-semibold tabular-nums text-white">{reps}</p>
            <p className="mt-1 text-xs uppercase tracking-widest text-white/60">You</p>
          </div>
        </div>

        <Button onClick={onFinish} size="lg" className="mt-8 w-full">
          Finish
        </Button>
      </div>
    </div>
  );
}
